import { colors } from '@insurancemenu/imenu-components-lib';
import { breakpoints, boxShadows } from '@insurancemenu/imenu-components-lib/dist/utils';
import AppBackground from 'assets/images/app-background.svg';
import { createUseStyles } from 'react-jss';

const styles = {
  appWrapper: {
    padding: '5rem',
    backgroundImage: `url(${AppBackground})`,
    backgroundSize: 'cover',
    backgroundPosition: 'center',
    width: '100%',
    minHeight: '100vh',
    boxSizing: 'border-box',
  },
  title: {
    fontSize: '3.4rem',
    textAlign: 'center',
    margin: '0 0 4rem',
    [breakpoints.sm.down]: {
      fontSize: '2.8rem',
    },
  },
  formWrapper: {
    // Layout
    maxWidth: '50rem',
    minHeight: '40rem',
    padding: '3.8rem',
    margin: '0 auto',
    overflowY: 'auto',
    position: 'relative',
    boxSizing: 'border-box',
    // Styles
    backgroundColor: colors.neutral.white,
    borderRadius: '1rem',
    boxShadow: boxShadows.light[8],
    border: '0.2rem solid #A0C4FB',

    [breakpoints.sm.down]: {
      padding: '2.8rem',
      maxHeight: '100%',
    },
  },
};

const createStyles = createUseStyles(styles);

export { createStyles };
